import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CoaMappingEllipsisText } from "./CoaMappingEllipsisText";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { InfoIcon } from "@icons";
import { CoaMappingRow } from "../coaMappingRowTypes";
import styles from "../CoaMappingDrawer.module.scss";

export const CoaMappingNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CoaMappingRow, unknown>) => {
        const { name, sourceNumber, isParentPostingRow, kind } = row.original;
        const label =
            sourceNumber !== null ? `${sourceNumber} - ${name}` : name;
        return (
            <ViewTableCell className={styles.clippedCellHost}>
                <span className={styles.nameCell}>
                    <CoaMappingEllipsisText
                        text={label}
                        className={
                            kind === "account" ? undefined : styles.headerName
                        }
                    />
                    {isParentPostingRow && (
                        <Tooltip content="Activity booked directly on the parent account, mapped separately from its sub-accounts.">
                            <span className={styles.postingRowMarker}>
                                <InfoIcon className="icon-color-gray-500" />
                            </span>
                        </Tooltip>
                    )}
                </span>
            </ViewTableCell>
        );
    },
);

CoaMappingNameCell.displayName = "CoaMappingNameCell";
